// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__WgZ0F","loadingInline":"Loading_loadingInline__BeP-x"};